import type { ProColumns } from '@ant-design/pro-components';
import { ProTable } from '@ant-design/pro-components';
import { Input, Space, Tag } from 'antd';
import { useState } from 'react';
import { DepartmentScoreItemDTO, examReportController } from '../../api';
import DepartmentSelect from '../../components/DepartmentSelect';
import { useCompany } from '../../hooks/company';
import AttemptAdminResultDrawer from './AttemptAdminResultDrawer';
import { formatDuration } from './constants';

// 部门成绩（考试成绩页的 Tab）：本部门及子部门所有人的最高分成绩（权限 page:exam:score:department），
// 可点开答题详情看错在哪几题
export default ({ examId }: { examId: I.ID }) => {
  const { id: companyId } = useCompany();
  const [departmentId, setDepartmentId] = useState<I.ID>();
  const [keyword, setKeyword] = useState<string>();
  const [detailAttemptId, setDetailAttemptId] = useState<I.ID>();

  const columns: ProColumns<DepartmentScoreItemDTO>[] = [
    { title: '姓名', dataIndex: 'userName' },
    { title: '部门', dataIndex: 'departmentName' },
    { title: '最高分', dataIndex: 'score', width: 90 },
    {
      title: '是否通过',
      dataIndex: 'pass',
      width: 100,
      render: (_, record) =>
        record.pass ? <Tag color="green">通过</Tag> : <Tag color="red">未通过</Tag>,
    },
    { title: '作答次数', dataIndex: 'attemptCount', width: 90 },
    {
      title: '用时',
      dataIndex: 'durationSeconds',
      width: 110,
      render: (_, record) => formatDuration(record.durationSeconds),
    },
    { title: '交卷时间', dataIndex: 'submittedAt', width: 170 },
    {
      title: '操作',
      valueType: 'option',
      width: 100,
      render: (_, record) => (
        <a onClick={() => setDetailAttemptId(record.attemptId as I.ID)}>
          答题详情
        </a>
      ),
    },
  ];

  return (
    <>
      <Space style={{ marginBottom: 12 }}>
        <DepartmentSelect
          style={{ minWidth: 220 }}
          placeholder="部门（默认本部门及子部门）"
          value={departmentId}
          onChange={(value) => setDepartmentId(value)}
        />
        <Input.Search
          placeholder="姓名搜索"
          allowClear
          onSearch={(value) => setKeyword(value || undefined)}
          style={{ width: 180 }}
        />
      </Space>
      <ProTable<DepartmentScoreItemDTO>
        rowKey="userId"
        columns={columns}
        search={false}
        options={false}
        params={{ examId, departmentId, keyword }}
        pagination={{ pageSize: 20 }}
        request={async ({ current, pageSize }) => {
          const data = await examReportController.departmentScore(
            companyId,
            current ?? 1,
            pageSize ?? 20,
            { examId, departmentId, keyword },
          );
          return { data: data.list, success: true, total: data.total };
        }}
      />
      {detailAttemptId && (
        <AttemptAdminResultDrawer
          attemptId={detailAttemptId}
          onClose={() => setDetailAttemptId(undefined)}
        />
      )}
    </>
  );
};
